import React from 'react';

// Font Awesome 6 (already loaded page-wide) file-type icons, tinted with the
// suite colors people recognize. Unknown extensions fall back to the generic
// document icon in the default primary tint.
const TYPES = {
    pdf:  { icon: 'fa-file-pdf',        variant: 'is-pdf' },
    doc:  { icon: 'fa-file-word',       variant: 'is-word' },
    docx: { icon: 'fa-file-word',       variant: 'is-word' },
    xls:  { icon: 'fa-file-excel',      variant: 'is-excel' },
    xlsx: { icon: 'fa-file-excel',      variant: 'is-excel' },
    ppt:  { icon: 'fa-file-powerpoint', variant: 'is-ppt' },
    pptx: { icon: 'fa-file-powerpoint', variant: 'is-ppt' },
};

export default function FileBadge({ filename }) {
    const extension = ((filename || '').split('.').pop() || '').toLowerCase();
    const type = TYPES[extension] || { icon: 'fa-file-lines', variant: '' };

    return (
        <span className={`ea-file-ext ${type.variant}`} title={extension.toUpperCase()}>
            <i className={`fa-solid ${type.icon}`} />
        </span>
    );
}
